import { useId } from 'react';
import { NumberInput } from '../ui/NumberInput';
import { inputCls } from '../ui/styles';
import { SERIES_MAX_COUNT, SERIES_MAX_WEEKS, seriesEnd } from '../../core/rules/series';
import { dayMedium } from '../../core/format/dates';
export type Repeat = {
  everyWeeks: number;
  count: number;
} | null;
type Props = {
  date: string;
  value: Repeat;
  onChange: (next: Repeat) => void;
};
const WEEK_OPTIONS = Array.from({
  length: SERIES_MAX_WEEKS
}, (_, i) => i + 1);

/**
 * "Herhalen": niet, of elke N weken, M keer. Vooral voor kuren en vaste klanten. Elke datum wordt
 * een losse afspraak; wat niet lukt (dicht, bezet) hoor je na het inplannen.
 */
export function RepeatChoice({
  date,
  value,
  onChange
}: Props) {
  const id = useId();
  return <div className="space-y-2" data-id="element-497" data-mp="3qoyehn7m036h">
      <label htmlFor={`${id}-every`} className="block text-[13px] text-ink" data-id="element-498" data-mp="1sx3wfzh0wgfw">
        Herhalen
      </label>
      <div className="flex flex-wrap items-center gap-2" data-id="element-499" data-mp="1ow1xljr0q6eg">
        <select id={`${id}-every`} value={value?.everyWeeks ?? 0} onChange={e => {
        const weeks = Number(e.target.value);
        onChange(weeks ? {
          everyWeeks: weeks,
          count: value?.count ?? 6
        } : null);
      }} className={`${inputCls} w-auto`} data-id="element-500" data-mp="1owk2t5vnruyi">
          <option value={0} data-id="element-501" data-mp="3q96723ytxth3">Niet herhalen</option>
          {WEEK_OPTIONS.map(w => <option key={w} value={w} data-id="element-502" data-mp="3uahp9ofdjcf9">
              {w === 1 ? 'Elke week' : `Elke ${w} weken`}
            </option>)}
        </select>
        {value && <label className="flex items-center gap-2" data-id="element-503" data-mp="qqdb1kog5vy7">
            <span className="sr-only" data-id="element-504" data-mp="d0jk8wtdt1lu">Hoe vaak in totaal</span>
            <NumberInput value={value.count} onChange={v => onChange({
          ...value,
          count: Math.min(SERIES_MAX_COUNT, Math.max(2, Math.round(v ?? 2)))
        })} min={2} max={SERIES_MAX_COUNT} className="w-20" data-id="element-505" data-mp="d01glf4e3l3w" />
            <span className="text-[13px] text-muted" data-id="element-506" data-mp="19jqy73lx4y39">keer</span>
          </label>}
      </div>
      {value && date && <p className="text-[12px] text-muted" aria-live="polite" data-id="element-507" data-mp="1jbtuvqo5mr16">
          {value.count} afspraken, t/m {dayMedium(seriesEnd(date, value.everyWeeks, value.count))}. Elke datum wordt apart gecontroleerd.
        </p>}
    </div>;
}